import React from "react";

export default function Branding() {
  return (
    <div className="container py-5">
      <div className="row mb-5 pb-5">
        <div className="col">
          <h1 className="text-center fw-bold " style={{ fontSize: 36 }}>
            As Featured In
          </h1>
        </div>
      </div>
      <div className="row mb-5 gy-5 align-items-center">
        <div className="col-6 col-md-3 col-lg-3 text-center">
          <img src="./images/image12.jpg" alt="" width="84px" />
        </div>
        <div className="col-6 col-md-3 col-lg-3 text-center">
          <img src="./images/image6.jpg" alt="" width="126px" />
        </div>
        <div className="col-6 col-md-3 col-lg-3 text-center">
          <img src="./images/newsweek.svg" alt="" width="126px" />
        </div>
        <div className="col-6 col-md-3 col-lg-3 text-center">
          <img src="./images/image5.jpg" alt="" width="126px" />
        </div>
        <div className="col-6 col-md-3 col-lg-3 text-center">
          <img src="./images/image15.jpg" alt="" width="126px" />
        </div>
        <div className="col-6 col-md-3 col-lg-3 text-center">
          <img src="./images/yahoo.jpg" alt="" width="126px" />
        </div>
        <div className="col-6 col-md-3 col-lg-3 text-center">
          <img src="./images/american-spa.webp" alt="" width="126px" />
        </div>
        <div className="col-6 col-md-3 col-lg-3 text-center ">
          <img src="./images/image16.jpg" alt="" width="126px" />
        </div>
      </div>
    </div>
  );
}
